import { Address, MenuItem, User } from '@app/types';
import { LocalStorage } from '@app/utils/storage';

export const AddressStorage = {
  get() {
    const addressAsString = LocalStorage.getItem('addresses');
    return addressAsString ? (JSON.parse(addressAsString) as Address[]) : [];
  },
  save(addressToSave: Address) {
    let addresses = this.get();

    const alreadyHaveAddress = addresses.some((ad) => ad.id === addressToSave.id);
    if (alreadyHaveAddress) {
      addresses = addresses.map((address) => {
        if (address.id === addressToSave.id) return addressToSave;
        return address;
      });
    } else {
      addresses.push(addressToSave);
    }
    LocalStorage.setItem('addresses', JSON.stringify(addresses));
  },
  getByCityUrl(cityUrl: string) {
    const addresses = this.get();
    return addresses.find((address) => address.city.Url_Cidade === cityUrl) ?? null;
  },
};

export const UserStorage = {
  save(user: User) {
    LocalStorage.setItem('user', JSON.stringify(user));
  },
  get() {
    const userAsString = LocalStorage.getItem('user');
    return userAsString ? (JSON.parse(userAsString) as User) : null;
  },
};

type FavoritedMenuItemInfo = {
  id: string;
};

export const FavoritedMenuItemsStorage = {
  getAll(): FavoritedMenuItemInfo[] {
    const favoritedAsString = LocalStorage.getItem('favorites');
    return favoritedAsString ? JSON.parse(favoritedAsString) : [];
  },
  add(menuItemId: string) {
    const favorites = this.getAll();
    const info: FavoritedMenuItemInfo = { id: menuItemId };
    LocalStorage.setItem('favorites', JSON.stringify([info, ...favorites]));
  },
  addAll(...menuItemsIds: string[]) {
    const favorites = this.getAll();
    const infos: FavoritedMenuItemInfo[] = menuItemsIds.map((id) => ({ id }));
    LocalStorage.setItem('favorites', JSON.stringify([...infos, ...favorites]));
  },
  remove(menuItemId: string) {
    const filtered = this.getAll().filter((info) => info.id !== menuItemId);
    LocalStorage.setItem('favorites', JSON.stringify(filtered));
  },
  isFavorited(menuItemId: string) {
    return !!this.getAll().find((info) => info.id === menuItemId);
  },
};
